// extracted by mini-css-extract-plugin
module.exports = {"rootTouchBuffer":"Handle_rootTouchBuffer__2VinS","visibleHandle":"Handle_visibleHandle__3O_0G","dragged":"Handle_dragged__B938m"};